import { ChangeDetectorRef, Component, ElementRef, Input, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { gsap } from "gsap"; 
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { IconComponent } from '../../atoms/icon/icon.component';

@Component({
  selector: 'app-importante',
  standalone: true,
  imports: [
    CommonNgModule,
    IconComponent
  ],
  templateUrl: './importante.component.html',
  styleUrl: './importante.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ImportanteComponent {
  @ViewChild("boxImportante") boxImportante!: ElementRef;
  viewIn: boolean = true;

  @Input() Theme: any;
  @Input() titulo: any;
  @Input() mensage: any;

  constructor(private renderer: Renderer2, private ref: ChangeDetectorRef) {}

  ngOnInit() {}

  public cerrar(): void {
    gsap.to(this.boxImportante.nativeElement, 0.5, {
      height: 0,
      onComplete: () => {
        gsap.to(this.boxImportante.nativeElement, 0.5, {
          margin: 0,
          onComplete: () => {
            this.viewIn = false;
            this.ref.detectChanges();
          },
        });
      },
    });
  }
}
